import { useRouter } from 'next/router'

import { ProjectHeroRebrand } from 'src/components/molecules/ProjectHeroRebrand'
import { ProjectStatsBandRebrand } from 'src/components/organisms/ProjectStatsBandRebrand'
import { ViewPublicProject } from 'src/components/organisms/ViewPublicProject'

import { env } from 'src/env/client.mjs'
import { NotFound } from 'src/pages/404/404'
import { trpc } from 'src/utils/trpc'

const buildLocationText = (
  district?: string | null,
  region?: string | null
) => {
  if (district && region) return `${district}, ${region}`
  return district || region || undefined
}

const ProjectDetailSectionRebrand = () => {
  const router = useRouter()
  const { uri } = router.query as { uri: string }

  const { data, isLoading } = trpc.useQuery([
    'projects.getProjectByUri',
    { uri }
  ])

  if (isLoading) return null
  if (!data) return <NotFound />

  const locationText = buildLocationText(data.District?.Name, data.Region?.Name)
  const imageUrl = data.Hero
    ? `${env.NEXT_PUBLIC_ASSETS_DOMAIN}/${data.Hero}`
    : undefined

  return (
    <>
      <ProjectHeroRebrand
        name={data.Name}
        locationText={locationText}
        imageUrl={imageUrl}
      />
      <ProjectStatsBandRebrand projectData={data} />
      <ViewPublicProject projectData={data} />
    </>
  )
}

export default ProjectDetailSectionRebrand
